import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { WORKFLOW_STATUS, WORKFLOW_TYPE } from "../../constants";
import { useWorkflowsData } from "../../context/WorkflowsDataProvider";
import { CommunityMemberColumn } from "../CommunityMemberColumn";
import { ActionGroup } from "../NewWorkflowV2/ActionGroup";
import { WorkflowsTable } from "../Table";
import { Actions } from "../Table/Actions";
import { Datetime } from "../Table/Datetime";
import { WorkflowName } from "../Table/WorkflowName";
import { columnStyles } from "./columnStyles";

const i18nRoot = "settings.workflows.table";

const columns = ({ refetch }) => [
  {
    accessorKey: "name",
    header: t([i18nRoot, "name"]),
    thClassName: columnStyles.title,
    cellClassName: columnStyles.title,
    cell: info => (
      <WorkflowName>
        {info.getValue() || t([i18nRoot, "untitled_workflow"])}
      </WorkflowName>
    ),
  },
  {
    accessorKey: "workflow_type",
    header: t([i18nRoot, "type.title"]),
    thClassName: columnStyles.workflowType,
    cellClassName: columnStyles.workflowType,
    cell: info => (
      <span className="break-normal">
        {t([i18nRoot, "type", info.getValue() || "unknown"])}
      </span>
    ),
  },
  {
    accessorKey: "steps",
    header: t([i18nRoot, "steps"]),
    thClassName: columnStyles.steps,
    cellClassName: classNames("!py-0", columnStyles.steps),
    cell: info => (
      <ActionGroup
        actions={info.getValue()}
        size="md"
        truncationLimit={3}
        className="flex-wrap py-4"
      />
    ),
  },
  {
    accessorKey: "created_by_community_member_id",
    header: t([i18nRoot, "created_by"]),
    thClassName: columnStyles.user,
    cellClassName: columnStyles.user,
    cell: info => (
      <CommunityMemberColumn id={info.getValue()} isLastNameHidden />
    ),
  },
  {
    accessorKey: "created_at",
    header: t([i18nRoot, "created_on"]),
    thClassName: columnStyles.dateShort,
    cellClassName: columnStyles.dateShort,
    cell: info => <Datetime date={info.getValue()} />,
  },
  {
    accessorKey: "last_run_at",
    header: t([i18nRoot, "last_run"]),
    thClassName: columnStyles.dateLong,
    cellClassName: columnStyles.dateLong,
    cell: info => <Datetime date={info.getValue()} shouldIncludeTime />,
  },
  {
    accessorKey: "actions",
    header: "",
    cellClassName: "cursor-default",
    onClick: ({ event }) => event.stopPropagation(),
    cell: ({ row }) => <Actions workflow={row.original} refetch={refetch} />,
  },
];

const getColumns =
  shouldShowFewerColumns =>
  ({ refetch }) => {
    const allColumns = columns({ refetch });

    if (!shouldShowFewerColumns) {
      return allColumns;
    }

    const reducedColumnKeys = [
      "name",
      "workflow_type",
      "created_by_community_member_id",
    ];
    return allColumns.filter(column =>
      reducedColumnKeys.includes(column.accessorKey),
    );
  };

export const ArchivedTable = () => {
  const { category } = useWorkflowsData();

  return (
    <WorkflowsTable
      columns={getColumns(category)}
      workflowType={WORKFLOW_TYPE.ALL}
      status={WORKFLOW_STATUS.ARCHIVED}
    />
  );
};
